import React from "react";
import { useLocation } from "react-router-dom";
import { SignatureCompletionData, useNavigation } from "../../../hooks";
import {
  InstitutionWithDatasets,
  omniAuthService,
} from "../../../services/index";
import MyDataAgreementPage from "../../common/MyDataAgreementPage";

const TransmissionDemandNewPage: React.FC = () => {
  const location = useLocation();
  const { goBack } = useNavigation();

  // location.state에서 선택된 기관 정보 가져오기
  const selectedInstitutions: InstitutionWithDatasets[] =
    location.state?.selectedInstitutions || [];

  // 선택된 기관이 없으면 에러 화면 표시
  if (selectedInstitutions.length === 0) {
    return (
      <div className="h-screen-dvh bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-500 mb-4">선택된 기관이 없습니다.</p>
          <button
            onClick={goBack}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            돌아가기
          </button>
        </div>
      </div>
    );
  }

  // 전자서명 완료 시 단일 기관 연결 API 호출
  const handleSignatureComplete = async (data: SignatureCompletionData) => {
    const firstTransmission = data.provideInstitutionTransmissionList[0];

    if (
      !firstTransmission?.signatureResult ||
      !firstTransmission.provideInstitutionNo
    ) {
      throw new Error("전송 데이터가 올바르지 않습니다.");
    }

    await omniAuthService.createSingleTransmission({
      provideInstitutionNo: firstTransmission.provideInstitutionNo,
      signatureResult: firstTransmission.signatureResult,
    });
  };

  return (
    <MyDataAgreementPage
      title="기관 데이터 연결"
      onBack={goBack}
      successMessage="기관 데이터 연결이 완료되었습니다."
      buttonText="연결 완료"
      autoAgreeButtonText="동의하고 연결하기"
      selectedInstitutions={selectedInstitutions}
      onSignatureComplete={handleSignatureComplete}
      successNavigateTo="/settings/institution-connection"
    />
  );
};

export default TransmissionDemandNewPage;
